import React, {useState} from "react";
import { Button, Column, Columns, Control, Field, Input, Modal, Section, Title } from "@allxsmith/bestax-bulma";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import axios from "axios";
import {useDispatch} from "react-redux";
import {createSetJobFieldAction} from "../../../actions/dataActions";
import {ToastContainer, toast} from "react-toastify";


export default function ToQuoteModal({open, setOpen, job, endpoint, history}){

    const [isLoading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [contactSearchData, setContactSearchData] = useState([]);
    const [typeahead, setTypeahead] = useState();
    const dispatch = useDispatch();
    const handleVehicleSearch = query => {
        setLoading(true);
        let url = endpoint + `vehicles?search=${query}`;
        axios.get(url).then(resp => {
        setSearchData(resp.data.results);
        setLoading(false);
        });
    };

    const handleContactSearch = query => {
        setLoading(true);
        let url = endpoint + `contacts?search=${query}&type=CC`
        axios.get(url).then(res => {
            setContactSearchData(res.data.results);
            setLoading(false);
        })
    }
    const triggerChange = data => {
        dispatch(createSetJobFieldAction(data));
    }
    const handleVehicleSelect = e => {
        triggerChange({vehicle: e[0]});
        setSearchData([]);
    }
    const handleContact1Select = e => {
        triggerChange({"customer": e[0]});
        setContactSearchData([]);
    }
    const handleContact2Select = e => {
        triggerChange({"customer2": e[0]});
        setContactSearchData([]);
    }

    const validator = (data) => {
        if(data.vehicle && data.customer){
            return true
        }
        else{
            toast.warning("Vehicle and Customer 1 are required", {position: "top-right"});
            return false
        }
    }
    const enquiryToQuote = () => {
        if(validator(job)) {
            const conf = {
                data: job,
                method: "post",
                url: endpoint + "enquiryquote"
            }
            axios(conf).then((res) => {
                if (res.data && res.data.id) {
                    window.open("/editquote/" + res.data.id, "_self");
                }
            }).catch(err => {
                toast.error("An error occured!", {position: "top-right"});
            })
        }
    }



    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            active={open}
            onClose={() =>
                setOpen(false)
            }
            closeOnBlur
        >
            <Modal.Content>
                <Section style={{background:"white"}}>
                    <Title>Enquiry To Quote</Title>
                    <Columns isMultiline>
                        <Column>
                            <Field>
                                <label className="label">Vehicle</label>
                                <Control>
                                    <AsyncTypeahead
                                      useCache={false}
                                      data-testid="vehicle-search"
                                      id="typeahead"
                                      labelKey="registration"
                                      minLength={2}
                                      name={"registration"}
                                      onSearch={handleVehicleSearch}
                                      onChange={handleVehicleSelect}
                                      placeholder={"Search Vehicle Registration"}
                                      options={searchData}
                                      ref={typeahead => setTypeahead(typeahead)}
                                      className="typeahead"
                                      isLoading={isLoading}
                                    />
                                </Control>
                            </Field>
                        </Column>
                        <Column>
                            <Field>
                                <label className="label">Registration</label>
                                <Input
                                    type={"text"}
                                    disabled={true}
                                    readOnly={true}
                                    value={job.vehicle? job.vehicle.registration : ""}
                                />
                            </Field>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Field>
                                <label className="label">Customer 1</label>
                                <Control>
                                    <AsyncTypeahead
                                      useCache={false}
                                      data-testid="customer1-search"
                                      id="typeahead"
                                      labelKey="display_name"
                                      minLength={2}
                                      name={"customer"}
                                      onSearch={handleContactSearch}
                                      onChange={handleContact1Select}
                                      placeholder={"Search Customer"}
                                      options={contactSearchData}
                                      ref={typeahead => setTypeahead(typeahead)}
                                      className="typeahead"
                                      isLoading={isLoading}
                                    />
                                </Control>
                            </Field>
                        </Column>
                        <Column>
                            <Field>
                                <label className="label">Customer 1 Name</label>
                                <Input
                                    disabled={true}
                                    readOnly={true}
                                    value={job.customer ? job.customer.display_name : ""}
                                />
                            </Field>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Field>
                                <label className="label">Customer 2</label>
                                <Control>
                                    <AsyncTypeahead
                                      useCache={false}
                                      data-testid="customer2-search"
                                      id="typeahead"
                                      labelKey="display_name"
                                      minLength={2}
                                      name={"customer2"}
                                      onSearch={handleContactSearch}
                                      onChange={handleContact2Select}
                                      placeholder={"Search Customer"}
                                      options={contactSearchData}
                                      ref={typeahead => setTypeahead(typeahead)}
                                      className="typeahead"
                                      isLoading={isLoading}
                                    />
                                </Control>
                            </Field>
                        </Column>
                        <Column>
                            <Field>
                                <label className="label">Customer 2 Name</label>
                                <Input
                                    disabled={true}
                                    readOnly={true}
                                    value={job.customer2 ? job.customer2.display_name : ""}
                                />
                            </Field>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Button
                                color={"success"}
                                onClick={enquiryToQuote}
                                isFullWidth
                            >
                                Turn Into Quote
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );






}